import { TFunction } from "i18next";
import * as yup from "yup";

export interface OibValidationSchemeProps {
  t: TFunction;
}

export const OibValidationScheme = ({
  t,
}: OibValidationSchemeProps) => {
  const requiredMsg = t("validations.required");
  const oibFormat = t("validations.oibFormat");
  const oibFormatValidation = t("validations.oibValidation");

  return yup.object().shape({
    oib: yup
      .string()
      .matches(/^[0-9]+$/, oibFormat)
      .required(requiredMsg)
      .max(11, oibFormat)
      .test("checkOibValidation", "isRequired", function (value) {
        var oibValue = value?.toString().padStart(11, "0") ?? "";
        var length = oibValue?.length ?? 0;

        if (length) {
          var residue = 10;
          for (var i = 0; i < length - 1; i++) {
            var digit = parseInt(oibValue[i]);
            var midResult = (digit + residue) % 10;
            midResult = midResult === 0 ? 10 : midResult;
            residue = (midResult * 2) % 11;
          }

          var lastDigit = parseInt(oibValue[length - 1]);
          var controllCharacter = 11 - residue;
          if (controllCharacter === lastDigit) {
            return true;
          } else if (controllCharacter === 10 && 0 === lastDigit) {
            return true;
          } else {
            return this.createError({
              path: "oib",
              message: oibFormatValidation,
            });
          }
        } else {
          return this.createError({
            path: "oib",
            message: oibFormatValidation,
          });
        }
      }),
  });
};